import { themesTable } from "./tables/theme";
import { categorysTable } from "./tables/category";
import { templatesTable } from "./tables/template";
import { productsTable } from "./tables/product";

export const DB_ENTITIES = {
  THEME: "themes",
  TEMPLATE: "templates",
  CATEGORY: "category",
  PRODUCT: "products",
};

export const DIALOG_TYPES = {
  CREATE: "creation",
  EDIT: "editing",
};

export const TABLE_CONFIG = {
  themes: {
    tableTitle: "Темы",
    fields: themesTable,
    tableColumnsToShow: [
      "id",
      "alias",
      "parent_id",
      "title_ru",
      "title_full_ru",
      "publish",
      "img_name",
    ],
    schemaFieldSlots: {
      sm: ["id", "alias", "parent_id", "title_ru", "title_ua", "publish"],
      md: [
        "title_full_ru",
        "title_full_ua",
        "description_ru",
        "description_ua",
        "text_ru",
        "text_ua",
      ],
      img: ["img_name"],
    },
    showMask: false,
    imageRatio: 16 / 9,
  },
  templates: {
    tableTitle: "Шаблоны",
    fields: templatesTable,
    tableColumnsToShow: [
      "id",
      "alias",
      "parent_id",
      "title_ru",
      "publish",
      "img_name",
    ],
    schemaFieldSlots: {
      sm: [
        "id",
        "alias",
        "sort",
        "parent_id",
        "title_ru",
        "title_ua",
        "publish",
      ],
      md: [
        "gender",
        "color",
        "description_ru",
        "description_ua",
        "text_ru",
        "text_ua",
      ],
      img: ["img_name"],
    },
    showMask: true,
    imageRatio: 10 / 19,
  },
  category: {
    tableTitle: "Категории",
    fields: categorysTable,
    tableColumnsToShow: [
      "id",
      "alias",
      "parent",
      "title_full",
      "title",
      "publish",
    ],
    schemaFieldSlots: {
      sm: ["id", "alias", "sort", "type", "brend_id", "serie_id", "publish"],
      md: ["title", "title_ua", "title_ru", "title_full"],
      img: ["img_name"],
    },
    showMask: false,
  },
  products: {
    tableTitle: "Продукты",
    fields: productsTable,
    tableColumnsToShow: [
      "id",
      "alias",
      "template_id",
      "model_id",
      "title_full_ru",
      "hits",
      "price",
      "img_generate",
      "publish",
    ],
    schemaFieldSlots: {
      sm: ["id", "alias", "template_id", "model_id", "publish"],
      md: [
        "title_ru",
        "title_ua",
        "title_full_ru",
        "title_full_ua",
        "description_ru",
        "description_ua",
      ],
      img: ["img_name"],
    },
    showMask: false,
  },
};
